import Helper from './Helper';
import ShareButtonLinks from './ShareButtonLinks';
import Video from './Video';
import LinkAddTargetBlank from './LinkAddTargetBlank';

class LoadArticleInPopup {
  constructor(config = {}) {
    const {
      article
    } = config;
    this.articles = Array.prototype.slice.call(document.querySelectorAll(article));
    let endpoints = document.querySelector('#endpoint-posts');
    this.popup = document.querySelector('.pop-up');
    this.popupInner = document.querySelector('.pop-up__wrapper');
    this.popupContent = document.querySelector('.pop-up__content');
    this.footer = document.querySelector('.footer');
    let close = document.querySelector('.js-popup-box-close');

    if(endpoints != null){
      this.fetchURL = endpoints.innerText;
    }
    this.articles.forEach((element, index) => {
      element.setAttribute('data-id', index); //add data-id for prev-next to have an index
      element.addEventListener('click', (e) => {
        e.preventDefault();
        this.getPost(element, this.articles);
      });
    });
    if(close) {
      close.addEventListener('click', () => this.closePopUp());
    }
  }

  getPost(element, array) {
    let index = parseInt(element.getAttribute('data-id'));
    let prevNext = this.getPrevNextLinks(array, index);
    let url = (element.href && element.href !== '' && element.href !== '#' && element.href !== window.location.href) ? this.getURL(element.href) : '#';
    if(element.innerHTML !== "" && url !== '#'){
      fetch(this.getURL(element.href), {headers: {
        'X-WP-Token': NSContext.token
      }}).then((response) => {
          return response.json();
        }).then((post) => {
          if(post.content){
            this.renderPopUp(post, prevNext, index);
          } else {
            this.popupContent.innerHTML = this.addPlaceholder
          }
        });
    } else {
      return;
    }
  }

  //fill out prev-next elements, ugly code
  getPrevNextLinks(array, index) {
    let prevNextObj = {};
    array.forEach((item, i) => {
      //check if there is an next element in array and if there is a correct url. If not, go back to main-page; add text of main-page in next element
      if(index + 1 === i) {
        if(item.href && (item.href !== window.location.href || item.href !== '#' || item.href !== '')) {
          prevNextObj.nextText = item.querySelector('.ns-story-tile__subtitle').innerHTML;
          prevNextObj.nextLink = item.href;
        } else {
          prevNextObj.nextText = document.querySelector('.ns-title-h1').innerHTML;
          prevNextObj.nextLink = '#';
        }
        //check if there is an prev element in array and if there is a correct url. If not, go back to main-page; add text of main-page in prev element
      } else if (index - 1 === i) {
        if(item.href && (item.href !== window.location.href || item.href !== '#' || item.href !== '')) {
          prevNextObj.prevText = item.querySelector('.ns-story-tile__subtitle').innerHTML;
          prevNextObj.prevLink = item.href;
        } else {
          prevNextObj.prevText = document.querySelector('.ns-title-h1').innerHTML;
          prevNextObj.prevLink = '#';
        }
        //when there is no previous element, add text of h1 of main page to prev and link to return
      } else if (index - 1 < 0) {
        prevNextObj.prevText = document.querySelector('.ns-title-h1').innerHTML;
        prevNextObj.prevLink = '#';
        //when there is no next element, add text of h1 of main page to next and link to return
      } else if (index + 1 >= array.length) {
        prevNextObj.nextText = document.querySelector('.ns-title-h1').innerHTML;
        prevNextObj.nextLink = '#';
      }
    });
    return prevNextObj;
  }

  renderPopUp(post, prevNext, index) {
    //remove content before add new one
    this.popupContent.innerHTML = '';
    let footerClone = document.querySelector('.footer--clone');
    if(footerClone) {
      footerClone.remove();
    }

    this.addClass(this.popup);
    this.popupContent.innerHTML = post.content;
    Helper.loadImagesInContainerRest(this.popupContent);
    let prevNextTemp = this.prevNextTemplate(prevNext.prevText, prevNext.prevLink, prevNext.nextText, prevNext.nextLink, index);
    let frag = document.createRange().createContextualFragment(prevNextTemp);

    let prevButton = frag.querySelector('.prev-next__link--prev-clone');
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      if(!prevButton.getAttribute('href') || prevButton.getAttribute('href') === '#') {
        this.closePopUp();
      } else {
        this.getPost(prevButton, this.articles);
      }
    });

    let nextButton = frag.querySelector('.prev-next__link--next-clone');
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      if(!nextButton.getAttribute('href') || nextButton.getAttribute('href') === '#') {
        this.closePopUp();
      } else {
        this.getPost(nextButton, this.articles);
      }
    });

    let totopButton = frag.querySelector('.js-totop-toggle');

    totopButton.addEventListener('click', e => {
      this.popup.scrollTo({top: 0, behavior: 'smooth'});
    });

    this.popupContent.appendChild(frag);

    if(this.footer) {
      let footerClone = this.footer.cloneNode(true);
      Helper.addClass(footerClone, 'footer--clone');
      this.popupInner.appendChild(footerClone);
    }

    new ShareButtonLinks({link: post.seo.url});
    new Video();

    new LinkAddTargetBlank({linkSelector: '.ns-link--target-blank'});

    this.popup.scrollTo({top: 0, behavior: 'smooth'});
  }

  //the same template as the normal prev-next template ist, onli a-tag with clone-class and the data-attribute to have an index
  prevNextTemplate(prev, prevlink, next, nextlink, id) {
    return `<section class="prev-next totop">
              <div class="totop__button js-totop-toggle"></div>
              <div class="prev-next__main">
                <div class="prev-next__prev">
                  <a data-id="${id - 1}" class="prev-next__link prev-next__link--prev prev-next__link--prev-clone" href="${prevlink}">
                    <div class="prev-next__icon prev-next__icon--prev">
                      <span class="nhs-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.412 31.995"><path d="M15.997 30.581L1.414 15.997 15.997 1.414" fill="none" stroke="#c8c8c8" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path></svg>
                      </span>
                    </div>
                    <div class="prev-next__text prev-next__text--prev prev-next__text--prev">
                      ${prev}
                    </div>
                  </a>
                </div>
                <div class="prev-next__next">
                  <a data-id="${id + 1}"class="prev-next__link prev-next__link--next prev-next__link--next-clone" href="${nextlink}">
                    <div class="prev-next__text prev-next__text--next">
                      ${next}
                    </div>
                    <div class="prev-next__icon prev-next__icon--next">
                      <span class="nhs-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.412 31.995"><path d="M15.997 30.581L1.414 15.997 15.997 1.414" fill="none" stroke="#c8c8c8" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path></svg>
                      </span>
                    </div>
                  </a>
                </div>
            </div>
          </section>`;
  }

  addClass(element) {
    if(!Helper.hasClass(element, 'pop-up--open')) {
      Helper.addClass(element, 'pop-up--open');
      setTimeout(()=> {
        Helper.addClass(element, 'pop-up--open-ani');
      }, 200);
    }
  }

  removeClass(element) {
    if(Helper.hasClass(element, 'pop-up--open')) {
      Helper.removeClass(element, 'pop-up--open-ani');
      setTimeout(()=> {
        Helper.removeClass(element, 'pop-up--open');
      }, 250);
    }
  }

  getURL(id) {
    let s = id.split('?p=');
    let newid = s[s.length - 1];
    return this.fetchURL.replace('posts/', 'posts/' + newid.replace('\p\=', '') + '/');
  }

  addPlaceholder() {
    return `<p>Post could not be loaded</p>`;
  }

  closePopUp() {
    this.removeClass(this.popup);
    let footerClone = document.querySelector('.footer--clone');
    footerClone.remove();
    this.popupContent.innerHTML = '';
  }
}
export default LoadArticleInPopup;
